export default __webpack_public_path__ + "static/media/MongoDB.c65cb9ed.png";